import React, { Component } from 'react'

import { Dialog } from 'primereact/dialog';


export default class TemplateView extends Component {
    constructor(props) {
        super(props);
    }





    render() {
        const { template } = this.props;
        return (
            <Dialog header={'Template Details'}
                blockScroll={true} draggable={false}
                closeOnEscape={true}
                dismissableMask={true} visible={true}
                closable={true}
                style={{ width: '50%' }}
                onHide={this.props.onHide}>
                <div className='appointment-info'>
                    <div>
                        <span className='label-l1'> Name: </span>
                        <span className='label-v1'> {template.name}</span>
                    </div>
                    <div>
                        <span className='label-l1'> Subject: </span>
                        <span className='label-v1'> {template.subject}</span>
                    </div>
                    <div>
                        <span className='label-l1'> Message: </span>
                        <div className='template-w' dangerouslySetInnerHTML={{ __html: template.message }}></div>
                    </div>
                </div>
            </Dialog >
        )
    }
}
